import { render, staticRenderFns } from "./StatChartCard.vue?vue&type=template&id=4057c1ba&scoped=true&"
import script from "./StatChartCard.vue?vue&type=script&lang=ts&"
export * from "./StatChartCard.vue?vue&type=script&lang=ts&"
import style0 from "./StatChartCard.vue?vue&type=style&index=0&id=4057c1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4057c1ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VFlex,VRow})
